import { render, staticRenderFns } from "./modelloorganizzazione.vue?vue&type=template&id=59fdb8c2"
import script from "./modelloorganizzazione.vue?vue&type=script&lang=js"
export * from "./modelloorganizzazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports